import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d371338"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "radio-button-group row ml-4" }
const _hoisted_2 = { class: "col-4 ml-0" }
const _hoisted_3 = { class: "radio" }
const _hoisted_4 = ["name", "value", "onClick"]
const _hoisted_5 = { class: "radio-elmt mt-2 mb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark-box" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "radio-checkmark" })
], -1))
const _hoisted_7 = { class: "radio-text" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  key: 0,
  class: "col-6 ml-4"
}
const _hoisted_10 = { class: "input-box" }
const _hoisted_11 = { class: "select mb-4" }
const _hoisted_12 = { class: "input-label" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "- Please select -", -1))
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  key: 1,
  class: "col-6 ml-4"
}
const _hoisted_16 = { class: "input-box" }
const _hoisted_17 = { class: "input-label" }
const _hoisted_18 = {
  key: 2,
  class: "col-6 ml-4"
}
const _hoisted_19 = { class: "input-box" }
const _hoisted_20 = { class: "input-label" }

export function render(_ctx, _cache) {
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["dropdown-with-text", _ctx.validForm() ? 'answered' : ''])
  }, [
    _createElementVNode("h4", null, [
      _createTextVNode(_toDisplayString(_ctx.newWording) + " ", 1),
      _createVNode(_component_Popover, { popover: _ctx.obj }, null, 8, ["popover"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.responses, (option) => {
        return (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("label", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: _ctx.uniqueIdName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedOption) = $event)),
              value: option.value,
              onClick: $event => (_ctx.selected(option.value))
            }, null, 8, _hoisted_4), [
              [_vModelRadio, _ctx.selectedOption]
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(option.wording), 1)
            ])
          ])
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.selectedOption == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.question.atcsSubQuestions[0].wording), 1),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.selectedAccountingAppId) = $event))
                }, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.question.atcsSubQuestions[0].responses, (response) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: response.id
                    }, _toDisplayString(response.wording), 9, _hoisted_14))
                  }), 256))
                ], 512), [
                  [_vModelSelect, _ctx.selectedAccountingAppId]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedOption == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.question.atcsSubQuestions[1].wording), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.question.atcsSubQuestions[1].responses[0].answerTxt) = $event)),
                onInput: _cache[3] || (_cache[3] = $event => (_ctx.updateSubQuestionAnswer($event, _ctx.i)))
              }, null, 544), [
                [_vModelText, _ctx.question.atcsSubQuestions[1].responses[0].answerTxt]
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedOption == 3)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("h5", _hoisted_20, _toDisplayString(_ctx.question.atcsSubQuestions[2].wording), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.question.atcsSubQuestions[2].responses[0].answerTxt) = $event)),
                onInput: _cache[5] || (_cache[5] = $event => (_ctx.updateSubQuestionAnswer($event, _ctx.i)))
              }, null, 544), [
                [_vModelText, _ctx.question.atcsSubQuestions[2].responses[0].answerTxt]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}